export default function AppSection() {
  return (
    <section id="app" className="relative py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[9/16] max-w-[280px] mx-auto lg:mx-0 rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%20and%20warm%20themed%20UI%20design%2C%20clean%20minimal%20layout%20with%20film%20poster%20grid%2C%20soft%20warm%20lighting%20on%20the%20screen%2C%20elegant%20modern%20device%20presentation%2C%20dark%20phone%20frame%20with%20vibrant%20app%20content%2C%20simple%20neutral%20background%2C%20editorial%20product%20photography&width=560&height=996&seq=tangxin-app-01&orientation=portrait"
                alt="糖心视频移动端观影界面预览"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold mb-4">
              随时随地
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
              移动观影 · 精彩随行
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              糖心视频完美适配手机与平板，91在线视频和西瓜视频免费资源随手可得。
              通勤路上、午休时间、睡前放松，高清免费影视随心看，在线不缓冲体验不打折。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl">
                <i className="ri-android-line text-xl text-foreground-600"></i>
                <span className="text-sm font-medium text-foreground-700">Android 版</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl">
                <i className="ri-apple-line text-xl text-foreground-600"></i>
                <span className="text-sm font-medium text-foreground-700">iOS 版</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl">
                <i className="ri-computer-line text-xl text-foreground-600"></i>
                <span className="text-sm font-medium text-foreground-700">网页版</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}